import { AxiosRequestConfig } from "axios";
import ApiClient from "../../services/apiClient";

export const stateList = (opts?: AxiosRequestConfig) =>
  ApiClient.get(`/state`, opts);
